export default __webpack_public_path__ + "static/media/flag-indonesia.97c84150.svg";